import type { Menu } from "types/menu"
import { universalMenuItems } from "./universal"

export const wagonMenu: Menu = [
  {
    label: "Overview",
    items: [
      {
        label: "Live Wagons",
        to: "/",
      },
    ],
  },
  { separator: true },
  ...universalMenuItems({}),
]
